var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11113_58816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2737 19.0742C15.603 22.7449 9.3407 24.4025 4.28954 19.3495C-0.761628 14.2964 0.894184 8.03598 4.56489 4.36528C6.59838 2.32621 9.15651 1.11691 11.7742 0.947611C14.63 0.776448 17.3258 1.86854 19.549 4.09179C21.7723 6.31505 22.8513 8.99784 22.6802 11.8537C22.509 14.4695 21.296 17.0481 19.2737 19.0742Z",
    fill: "url(#paint0_radial_11113_58816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.431 7.03306C17.885 6.87538 17.3056 7.14539 17.075 7.66571C16.0599 9.5117 14.7849 11.2023 13.2889 12.6856C11.8068 14.1815 10.1158 15.4567 8.26902 16.4697C8.01851 16.5823 7.81682 16.7812 7.70069 17.0301C7.58456 17.279 7.56173 17.5614 7.63635 17.8257C7.79797 18.3677 8.33996 18.6338 8.85044 18.825C11.7102 19.8952 14.8577 19.0989 17.276 16.6944L17.2997 16.6727C19.7022 14.2544 20.4985 11.1069 19.4283 8.24515C19.2391 7.73667 18.971 7.19271 18.431 7.03306Z",
    fill: "#65471B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1237 16.4976L17.1118 16.5094V16.5213L17.1237 16.4976Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4839 12.8359L13.4621 12.8557L13.4424 12.8774L13.4839 12.8359Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4839 12.8359L13.4621 12.8557L13.4424 12.8774L13.4839 12.8359Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1237 16.4976L17.1118 16.5094V16.5213L17.1237 16.4976Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.075 7.66571C16.0599 9.5117 14.7849 11.2023 13.2889 12.6856C11.8068 14.1815 10.1158 15.4567 8.26902 16.4697C8.01851 16.5823 7.81682 16.7812 7.70069 17.0301C7.58456 17.279 7.56173 17.5614 7.63635 17.8257C7.66197 17.9065 7.69548 17.9834 7.73885 18.0563C7.81965 18.0287 7.89652 17.9972 7.97338 17.9597C10.4907 17.1248 12.772 15.7004 14.6271 13.8051C16.4461 12.026 17.8341 9.85455 18.6853 7.4568C18.7188 7.376 18.7483 7.29321 18.7738 7.20846C18.6715 7.12964 18.5551 7.06854 18.431 7.03306C17.885 6.87538 17.3056 7.14539 17.075 7.66571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4423 12.9818C14.5992 11.8623 15.356 10.7626 16.2666 9.42236C16.4933 9.08731 16.7081 8.74437 16.915 8.39158L17.0648 8.1255C17.1042 8.05653 17.1476 7.98952 17.1988 7.92842C17.2895 7.81609 17.4058 7.72935 17.5398 7.67417C17.8512 7.55986 18.1922 7.55395 18.5075 7.65841C19.1481 7.96587 19.7059 9.06169 19.6348 8.85672C19.6348 8.85672 19.5185 8.3975 19.5146 8.39158C19.357 7.99741 19.1954 7.55197 18.7874 7.20903C18.5731 7.04546 18.3184 6.94297 18.0505 6.91244C17.7827 6.88191 17.5115 6.92446 17.2659 7.0356C17.032 7.14174 16.8286 7.30509 16.6746 7.5106C16.5997 7.60518 16.5327 7.70768 16.4775 7.81609L16.3454 8.07624C16.1621 8.42115 15.967 8.76211 15.7542 9.09519C14.9973 10.3585 14.1045 11.5352 13.0915 12.6034L13.06 12.6349C12.0142 13.6359 10.86 14.5171 9.61876 15.2621C9.28371 15.4592 8.94472 15.6563 8.5998 15.8534L8.33177 15.9894C8.22336 16.0446 8.12088 16.1096 8.02628 16.1865C7.81967 16.3399 7.65552 16.5434 7.54931 16.7777C7.44563 17.022 7.40924 17.2895 7.44388 17.5526C7.47854 17.8156 7.583 18.0646 7.74641 18.2737C8.27658 18.9654 9.48671 19.062 9.49262 19.062C9.68972 19.1331 8.49536 18.6244 8.1879 17.9839C8.07949 17.6799 8.07949 17.3478 8.1879 17.0438C8.23913 16.9059 8.32388 16.7837 8.43621 16.6891C8.49731 16.6378 8.56432 16.5945 8.63331 16.557L8.89938 16.4072C9.2502 16.2101 9.59314 15.9835 9.93017 15.7568C11.2684 14.8463 12.2952 14.1801 13.4088 13.0133",
    fill: "#EB8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5241 5.60592L11.8944 6.9577L12.5683 4.73305C12.5745 4.7059 12.5807 4.68045 12.5835 4.65318C12.6026 4.56105 12.6034 4.46605 12.5859 4.37362C12.5684 4.2812 12.5329 4.19316 12.4814 4.11454C12.4299 4.03593 12.3635 3.96829 12.2859 3.91549C12.2083 3.8627 12.1211 3.82579 12.0293 3.80689C11.938 3.78776 11.8424 3.7873 11.7496 3.80408C11.5452 3.85173 11.3603 3.96129 11.22 4.11796C11.0796 4.27461 10.9906 4.47078 10.9651 4.67986C10.8276 5.66929 10.5042 8.00068 10.3786 8.90838C10.3477 8.99788 10.3949 9.09571 10.484 9.12674C10.5429 9.14797 10.6083 9.13349 10.6544 9.09085L14.2693 6.99774L14.3412 6.95098C14.7803 6.64002 14.9097 6.01846 14.5803 5.64202C14.3293 5.35437 13.8753 5.35818 13.5241 5.60592Z",
    fill: "#65471B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88733 13.5637L7.11497 11.853L4.92275 12.6955L4.84867 12.721C4.46342 12.8298 4.05823 12.6166 3.94297 12.2437C3.91527 12.1551 3.90688 12.0623 3.91758 11.9702C3.94779 11.7654 4.04258 11.5747 4.18904 11.4242C4.33549 11.2737 4.52649 11.1706 4.73601 11.129L8.95041 10.2056C9.03886 10.1689 9.1416 10.2084 9.17985 10.294C9.20537 10.3505 9.1975 10.4158 9.15733 10.4629L7.3594 14.1818C7.34788 14.2083 7.33471 14.233 7.31981 14.2576C7.0439 14.7138 6.42448 14.8938 6.0157 14.5981C5.70312 14.3735 5.66893 13.9315 5.88733 13.5637Z",
    fill: "#65471B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1821 2.72699C22.6458 3.80227 21.8887 5.1282 20.9868 5.49403C20.3524 5.75062 19.5805 5.78772 18.4072 5.79645C18.2365 5.80742 18.0583 5.80156 17.8648 5.80275C17.1454 5.78886 16.4279 5.7338 15.7141 5.63872C15.6471 5.63192 15.5849 5.60063 15.5396 5.55083C15.4942 5.50104 15.4688 5.43624 15.4683 5.36887C15.473 5.30826 15.4987 5.25006 15.5388 5.20539C15.9035 4.57124 16.3459 3.98512 16.8559 3.46065C18.1402 2.12446 18.6882 1.84786 19.3226 1.59129C20.1909 1.21061 21.6778 1.55282 22.1821 2.72699Z",
    fill: "url(#paint1_radial_11113_58816)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11113_58816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.503 2.04018C20.9817 2.13306 21.1348 2.71745 20.5074 2.97693C20.1037 3.1399 18.0042 3.89432 18.153 3.43256C18.3962 2.67456 19.8269 1.90887 20.503 2.04018Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.72823 19.9194C2.86564 19.2679 3.03565 18.6954 4.09856 17.2349C4.51631 16.6562 5.00438 16.1324 5.55145 15.6744C5.58801 15.6275 5.6396 15.5948 5.69711 15.5799C5.83128 15.5558 5.9609 15.638 5.99899 15.7684C6.21175 16.4364 6.38591 17.1154 6.52379 17.8027C6.5548 17.9888 6.59112 18.1572 6.61032 18.3237C6.80124 19.456 6.89711 20.2032 6.75969 20.8545C6.56395 21.781 5.42174 22.7339 4.31169 22.4752C3.10432 22.1872 2.51906 20.821 2.72823 19.9194Z",
    fill: "url(#paint2_radial_11113_58816)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11113_58816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2991 18.489C4.715 18.265 4.3513 20.4058 4.26367 20.8216C4.12611 21.4681 3.53926 21.4209 3.36944 20.9794C3.12453 20.3596 3.61709 18.8503 4.2991 18.489Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11113_58816",
    x: 14.1455,
    y: -1.97461,
    width: 10.7764,
    height: 9.55469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_11113_58816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11113_58816",
    x: -0.694336,
    y: 14.4727,
    width: 9.18896,
    height: 10.8369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_11113_58816"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11113_58816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6449 11.3761) rotate(-45) scale(10.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11113_58816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6299 4.02099) rotate(-111.872) scale(4.77721 7.38861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3EC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E88E5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_11113_58816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.06472 16.0488) rotate(-167.888) scale(4.67314 7.15271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#29B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E88E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11113_58816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.814,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHype);
export default __webpack_public_path__ + "static/media/HYPE.8be94001a4a42e45be3171f8abc2c40f.svg";
export { ForwardRef as ReactComponent };